import React from "react"
import ReactTooltip from "react-tooltip"
import {Badge} from "../Badge/Badge"
import {BoundsTooltip} from "../InterestFormulaBox/BoundsTooltip"
import {CustomerInterestTier} from "../../resources/depositProduct"
import {isBasisPoints, getTierRateDisplay, getTierRangeDisplay} from "./interestUtils"
import FormulaTag from "./FormulaTag"

export default function TierRowView({
	tier,
	index,
	fedUpperBound,
	fedLowerBound,
}: {
	tier: CustomerInterestTier
	index: number
	fedUpperBound?: number
	fedLowerBound?: number
}) {
	const formula = tier.formula.trim()
	const isFormula = !isBasisPoints(formula)
	const rateDisplay = getTierRateDisplay(tier)
	const rangeDisplay = getTierRangeDisplay(tier)
	const tooltipId = `tier-formula-tooltip-${index}`

	return (
		<div className="tier-view-row">
			<div className="tier-header-line">
				<span className="tier-label">Tier {index + 1}</span>
				<span className="tier-separator">|</span>
				<span className="tier-range">{rangeDisplay}</span>
			</div>
			<div className="tier-rate-line">
				{rateDisplay && <span className="tier-rate">{rateDisplay}</span>}
				{isFormula && (
					<span className="formula-badge-wrapper">
						<span data-tip data-for={tooltipId}>
							<Badge text="Formula" icon="information-circle--interface-essential" className="formula-badge" />
						</span>
						<ReactTooltip id={tooltipId} effect="solid" place="top" className="tier-formula-tooltip">
							<div className="tier-formula-tooltip-content">
								<FormulaTag formula={formula} />
								{fedUpperBound !== undefined && fedLowerBound !== undefined && (
									<BoundsTooltip fedUpperBound={fedUpperBound} fedLowerBound={fedLowerBound} />
								)}
							</div>
						</ReactTooltip>
					</span>
				)}
			</div>
		</div>
	)
}
